import { type FC } from 'react';
import cn from 'classnames';

import { convertRemToPixels } from '@/common/lib/convertRemtoPx';

import css from './styles.module.scss';

import loaderIcon from '/img/icons/loader.png';

interface LoaderProps {
  size?: number;
  className?: string;
}

const Loader: FC<LoaderProps> = ({
  size = convertRemToPixels(1.25),
  className,
}) => {
  return (
    <img
      style={{ width: size + 'px', height: size + 'px' }}
      className={cn(css.loader, className)}
      src={loaderIcon}
      alt="loader"
    />
  );
};

export { Loader };
